export default "__VITE_ASSET__DlVdDkZw__"